import React from 'react';
import { Clock, AlertTriangle } from 'lucide-react';
import { useTranslation } from '../../../../contexts/I18nProvider';

interface SnapshotInfoBannerProps {
  lastSnapshotAt?: string;
  isStale: boolean;
}

/**
 * Small banner above the comparison table showing when the ERP snapshot
 * was last received. Turns into an orange warning when stale (>24h).
 */
export const SnapshotInfoBanner: React.FC<SnapshotInfoBannerProps> = ({ lastSnapshotAt, isStale }) => {
  const { t } = useTranslation();

  if (!lastSnapshotAt) {
    return (
      <div className="flex items-center gap-2 px-4 py-2 rounded-md bg-yellow-50 dark:bg-yellow-900/20 text-yellow-800 dark:text-yellow-300 text-sm border border-yellow-200 dark:border-yellow-800">
        <AlertTriangle size={16} />
        <span>{t('warehouse.modules.balanceComparison.banner.noSnapshot')}</span>
      </div>
    );
  }

  const date = new Date(lastSnapshotAt);
  const localFormatted = date.toLocaleString('no-NO', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });

  if (isStale) {
    return (
      <div className="flex items-center gap-2 px-4 py-2 rounded-md bg-orange-50 dark:bg-orange-900/20 text-orange-800 dark:text-orange-300 text-sm border border-orange-200 dark:border-orange-800">
        <AlertTriangle size={16} />
        <span>
          {t('warehouse.modules.balanceComparison.banner.stale', { time: localFormatted } as any) ||
            `ERP-snapshot er over 24 timer gammelt (${localFormatted}).`}
        </span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2 px-4 py-2 rounded-md bg-blue-50 dark:bg-blue-900/20 text-blue-800 dark:text-blue-300 text-sm border border-blue-200 dark:border-blue-800">
      <Clock size={16} />
      <span>
        {t('warehouse.modules.balanceComparison.banner.lastUpdated', { time: localFormatted } as any) ||
          `Sist oppdatert: ${localFormatted}`}
      </span>
    </div>
  );
};
